import { render, staticRenderFns } from "./Other-cards.vue?vue&type=template&id=e1e899ca&"
import script from "./Other-cards.vue?vue&type=script&lang=js&"
export * from "./Other-cards.vue?vue&type=script&lang=js&"
import style0 from "./Other-cards.vue?vue&type=style&index=0&id=e1e899ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports